var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"subscribe"},[_c('div',{staticClass:"inner"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(this.buttonObject)?_c('a',{attrs:{"href":this.buttonObject.url,"target":this.buttonObject.target},domProps:{"textContent":_vm._s(_vm.buttonLabel)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib?{}!./scripts/vue/SubscribeBanner.vue?vue&type=template&id=63def72c&scoped=true&
// module id = 195
// module chunks = 0